import { useMemo, useEffect, useRef } from 'react';
import { Box, Button, Paragraph } from 'theme-ui';
import { Svg } from '@snippets';
import { useSettings } from '@backpackjs/storefront';

import { themed } from './Personalize.theme';

export const Personalize = themed(({ theme, product, setIsOpen }) => {
  const personalizedEnabled = useMemo(
    () => product?.tags?.includes('personalized-enabled'),
    [product?.id]
  );

  const customizeBtn = useRef(null);
  const settings = useSettings();

  useEffect(() => {
    if (customizeBtn?.current) {
      const urlParams = new URLSearchParams(window.location.search);
      const isOpenModal = urlParams.get('recipe_id');
      if (isOpenModal) {
        customizeBtn.current.click();
      }
    }
  }, [customizeBtn?.current]);

  return personalizedEnabled ? (
    <Box data-comp={Personalize.displayName} sx={theme.wrapper}>
      <Button
        onClick={() => setIsOpen(true)}
        aria-label="Open Personalize Modal"
        sx={{ ...theme.button, variant: 'buttons.customize' }}
        ref={customizeBtn}
      >
        <Paragraph sx={{ fontWeight: '500', letterSpacing: '0.28px' }}>
          {settings?.product?.personalize?.buttonText || 'Customize'}
        </Paragraph>
        <Svg
          alt="personalization icon"
          src="/svgs/noprecache/svg/pencil-black.svg"
          viewBox="0 0 19 19"
          width="19px"
          height="19px"
          className="!ml-1"
        />
      </Button>
    </Box>
  ) : null;
});

Personalize.displayName = 'Personalize';
